<template>
<el-dialog :title="!dataForm.id ? '新增' : '修改'" width="60%" :append-to-body="true" :close-on-click-modal="false" :visible.sync="view.visible">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmit()" label-width="150px" class="code-type-dialog-form" size="mini">
        <el-row>
            <el-col :span="12">
                <el-form-item label="项目" prop="agreementType">
                    <span v-if="viewFlag === 'view'">{{getITEM_VALUE(dataForm.item)}}</span>
                    <el-select v-else v-model="dataForm.item" placeholder="请选择" size="mini">
                        <el-option v-for="item in ITEM_VALUE" :key="item.value" :label="item.label" :value="item.value" />
                    </el-select>
                </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item label="单价" prop="unitPrice">
                    <ctl-number :precision="3" :min="0" v-if="viewFlag !== 'view'" v-model="dataForm.unitPrice" placeholder="单价"></ctl-number>
                    <span v-else>{{dataForm.unitPrice}}</span>
                </el-form-item>
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="12">
                <el-form-item label="每小时消耗量" prop="consumption">
                    <ctl-number :precision="3" :min="0" v-if="viewFlag !== 'view'" v-model="dataForm.consumption" placeholder="每小时消耗量"></ctl-number>
                    <span v-else>{{dataForm.consumption}}</span>
                </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item label="每小时平均成本" prop="averageCost">
                    <ctl-number :precision="3" :min="0" v-if="viewFlag !== 'view'" v-model="dataForm.averageCost" placeholder="每小时平均成本"></ctl-number>
                    <span v-else>{{dataForm.averageCost}}</span>
                </el-form-item>
            </el-col>
        </el-row>
    </el-form>
    <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="view.visible = false">
            <span class="font-12 iconfont myicon-quxiao1"></span>&nbsp;取消
        </el-button>
        <el-button size="mini" type="primary" plain @click="dataFormSubmit()">
            <span class="font-12 iconfont myicon-tongguo"></span>&nbsp;确定
        </el-button>
    </span>
</el-dialog>
</template>

<script>
import {
    getRfqQuotationAuxiliaryMaterialsById,
    createRfqQuotationAuxiliaryMaterials,
    editRfqQuotationAuxiliaryMaterials
} from "@/controller/quotation";
import {
    ITEM_VALUE,
    getITEM_VALUE
} from '@/utils/const'
import {
    mapping
} from "@/utils"
import CtlNumber from '@/views/common/ctl-number'
export default {
    components: {
        CtlNumber
    },
    data() {
        return {
            view: {
                visible: false,
                conheight: {
                    height: this.$store.state.common.documentClientDefaultHeight *
                        0.9 -
                        410 +
                        "px",
                    "overflow-y": "auto",
                },
            },
            viewFlag: '',
            viewData: {},
            dataForm: {
                rfqId: '',
                rfqPartId: '',
                rfqSupplierId: '',
                roundNo: '',
                item: '',
                unitPrice: '',
                consumption: '',
                averageCost: ''
            },
            ITEM_VALUE: ITEM_VALUE,
            getITEM_VALUE: getITEM_VALUE,
        };
    },
    methods: {
        // 初始化
        init(id, viewFlag, data) {
            console.log(id, data)
            mapping(data, this.dataForm)
            this.dataForm.id = id || 0;
            this.viewFlag = viewFlag
            // this.dataForm.technicalNotifId = technicalNotifId;
            this.view.visible = true;
            this.$nextTick(() => {
                this.$refs["dataForm"].resetFields();
                if (this.dataForm.id) {
                    // TODO：根据id查零件
                    getRfqQuotationAuxiliaryMaterialsById({}, this.dataForm.id).then((data) => {
                        if (data && data.code === "00") {
                            this.dataForm = data.body;
                        }
                    });
                }
            });
        },
        // 表单提交
        dataFormSubmit() {
            this.$refs["dataForm"].validate((valid) => {
                if (valid) {
                    let Params = {
                        id: this.dataForm.id || undefined,
                        'id': this.dataForm.id || undefined,
                        'rfqId': this.dataForm.rfqId || undefined,
                        'rfqSupplierId': this.dataForm.rfqSupplierId || undefined,
                        'rfqPartId': this.dataForm.rfqPartId || undefined,
                        item: this.dataForm.item,
                        unitPrice: this.dataForm.unitPrice,
                        consumption: this.dataForm.consumption,
                        averageCost: this.dataForm.averageCost,
                    };
                    if (this.dataForm.id) {
                        // 更新辅助材料
                        editRfqQuotationAuxiliaryMaterials(Params)
                            .then((data) => {
                                if (data && data.code === "00") {
                                    this.$message({
                                        message: "操作成功",
                                        type: "success",
                                        duration: 1500,
                                        onClose: () => {
                                            this.view.visible = false;
                                            this.$emit(
                                                "refreshAuxiliaryMaterialsList"
                                            );
                                        },
                                    });
                                } else {
                                    this.$message.error(data.msg);
                                }
                            })
                            .catch((error) => {
                                console.log(error);
                            });
                    } else {
                        console.log(Params)
                        // 创建辅助材料
                        createRfqQuotationAuxiliaryMaterials(Params)
                            .then((data) => {
                                if (data && data.code === "00") {
                                    this.$message({
                                        message: "操作成功",
                                        type: "success",
                                        duration: 1500,
                                        onClose: () => {
                                            this.view.visible = false;
                                            this.$emit(
                                                "refreshAuxiliaryMaterialsList"
                                            );
                                        },
                                    });
                                } else {
                                    this.$message.error(data.msg);
                                }
                            })
                            .catch((error) => {
                                console.log(error);
                            });
                    }
                }
            });
        },
    },
};
</script>

<style lang="scss">
.el-dialog__body {
    .code-type-dialog-form {
        width: 100%;
    }
}
</style>
